import { Injectable } from '@angular/core'
import { LayoutService } from '@ftr/foundation'

@Injectable()
export class AppLayoutService implements LayoutService {}
